if (!customElements.get('bundle-progress')) {
  customElements.define(
    'bundle-progress',
    class BundleProgress extends HTMLElement {
      connectedCallback() {
        this.headingEl = this.querySelector('[data-bundle-progress-heading]');
        this.steps = Array.from(this.querySelectorAll('.bundle-progress__step'));
        this.setLevel(Number(this.dataset.level || 0), { silent: true });
      }

      headlineFor(level) {
        return this.getAttribute(`data-headline-${level}`) || '';
      }

      priceForLevel(level) {
        if (level < 1) return '';
        const step = this.steps.find((entry) => Number(entry.dataset.step || 0) === level);
        return step?.dataset.price || step?.querySelector('.bundle-progress__price')?.textContent?.trim() || '';
      }

      perServingForLevel(level) {
        if (level < 1) return '';
        const step = this.steps.find((entry) => Number(entry.dataset.step || 0) === level);
        return (
          step?.dataset.perServing ||
          step?.getAttribute('data-per-serving') ||
          step?.dataset.price ||
          ''
        );
      }

      /**
       * @param {number} level 0–4
       * @param {{ silent?: boolean }} [options]
       */
      setLevel(level, options = {}) {
        const next = Math.max(0, Math.min(4, Number(level) || 0));
        this.dataset.level = String(next);

        if (this.headingEl) {
          this.headingEl.textContent = this.headlineFor(next);
        }

        this.steps.forEach((step) => {
          const stepIndex = Number(step.dataset.step || 0);
          step.classList.toggle('is-active', stepIndex > 0 && stepIndex <= next);
        });

        if (!options.silent) {
          this.dispatchEvent(
            new CustomEvent('bundle-progress:change', {
              bubbles: true,
              detail: {
                level: next,
                quantity: this.quantityForLevel(next),
                perServingPrice: this.perServingForLevel(next),
                bagPrice: this.priceForLevel(next),
              },
            })
          );
        }
      }

      /**
       * Maps total stick-pack quantity to a progress level.
       * @param {number} quantity
       */
      setQuantity(quantity) {
        const qty = Number(quantity) || 0;
        let level = 0;

        for (let i = 1; i <= 4; i += 1) {
          const threshold = Number(this.getAttribute(`data-qty-${i}`) || 0);
          if (threshold > 0 && qty >= threshold) {
            level = i;
          }
        }

        this.setLevel(level);
      }

      quantityForLevel(level) {
        if (level < 1) return 0;
        return Number(this.getAttribute(`data-qty-${level}`) || 0);
      }
    }
  );
}
